import Lazyload from './Lazyload';

export default Lazyload;
